import React from 'react';
import {Link} from 'react-router-dom';

import {getNwIdSearchString} from '../../../state/workspaces/url';
import {useNavContext} from '../../NavContextProvider';
import {buildSingleRunLink, type SingleRunTarget} from './buildSingleRunLink';

type SingleRunLinkProps = {
  entityName: string;
  projectName: string;
  runName: string;
  linkText?: string;
};
export function SingleRunLink({
  entityName,
  projectName,
  runName,
  linkText,
}: SingleRunLinkProps) {
  const to = useSingleRunLink({entityName, projectName, runName});
  return (
    <Link to={to} target="_blank" rel="noopener noreferrer">
      {linkText || runName}
    </Link>
  );
}

/**
 * Returns the link to a workspace in single-run mode for the current page.
 * Reads the current route and named workspace, then calls buildSingleRunLink,
 * which documents the linking rules.
 */
export function useSingleRunLink(args?: SingleRunTarget): string {
  // must `useNavContext` instead of `useParams` because this hook is
  // used in the top nav bar where `useParams` are not populated
  const {params} = useNavContext();

  if (!args) {
    return '';
  }

  return buildSingleRunLink(params, args, getNwIdSearchString());
}
